import { render, staticRenderFns } from "./AiAttachmentPicker.vue?vue&type=template&id=3f0de608"
import script from "./AiAttachmentPicker.vue?vue&type=script&lang=js"
export * from "./AiAttachmentPicker.vue?vue&type=script&lang=js"
import style0 from "./AiAttachmentPicker.vue?vue&type=style&index=0&id=3f0de608&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports